module.exports = __webpack_public_path__ + "static/img/9.ad38883.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/9.png
// module id = IwNH
// module chunks = 1